import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';
import '../../assets/css/general/pagenotfound/PageNotFound.css';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="nf-page">

      {/* Floating blobs background */}
      <div className="nf-blob nf-blob--1" />
      <div className="nf-blob nf-blob--2" />
      <div className="nf-blob nf-blob--3" />

      {/* Content */}
      <div className="nf-content">

        {/* Big 404 */}
        <div className="nf-404-wrap">
          <span className="nf-four nf-four--left">4</span>
          <div className="nf-zero">
            <span className="nf-zero-inner">0</span>
            <div className="nf-zero-ring" />
          </div>
          <span className="nf-four nf-four--right">4</span>
        </div>

        {/* Oops */}
        <h1 className="nf-oops">Oops!</h1>

        {/* Label */}
        <p className="nf-label">PAGE NOT FOUND</p>

        {/* Description */}
        <p className="nf-desc">
          The page you are looking for might have been removed,<br />
          had its name changed, or is temporarily unavailable.
        </p>

        {/* Button */}
        <button className="nf-btn" onClick={() => navigate('/')}>
          <Home size={16} />
          Go to Homepage
        </button>

      </div>
    </div>
  );
};

export default PageNotFound;